<template>

	<div id="content" class="content join join_done">
		<div class="container">

			<div class="page-title">
				<h2 class="tit">NAVER 로그인 진행중</h2>
				<p class="sub-tit">NAVER 인증이 진행중입니다. 잠시만 기다려 주세요.</p>
				<input class="inp-id" type="text" id="deviceToken" v-show="LOCAL === 'localhost'" placeholder="장치 토큰" readonly="readonly">
			</div>

		</div>
	</div>

</template>

<script>

import $ from 'jquery'
import webUtils from "@/commons/utils/web.utils";

export default {
	name: "naverReturn",
	data() {

		return {
			LOCAL: location.hostname,
			isKeepSession: this.$route.query.isKeepSession,
		}
	},
	created() {

		const self = this

		this.$loadScript("ssflex/externals/naver/naverLogin_implicit-1.0.3.js")
		// this.$loadScript("https://static.nid.naver.com/js/naverLogin_implicit-1.0.3.js")
			.then((res) => {
				console.log(res)
				this.naverInit();
			})

	},
	updated() {

	},
	mounted() {
		this.appDeviceToken("#deviceToken")
	},
	methods: {


		naverInit () {

			const self = this

			const isKeepSession = $('#stay-login', opener.document).prop("checked");

			var naver_id_login = new window.naver_id_login(this.APIs.NAVER_LOGIN_KEY, this.APIs.NAVER_LOGIN_RETURN);
			// 접근 토큰 값 출력
			console.log("ACCESS TOKEN ::::::::::::: ", naver_id_login.oauthParams.access_token);
			// 네이버 사용자 프로필 조회
			naver_id_login.get_naver_userprofile((res) => {
				console.log("TEST :::::::::::::::: ", res);
				//alert(res.id);

				// DONE : SNS 정보로 로그인 및 없을 경우 저장 후 가입폼으로
				// $.get(self.APIs.SESSION + "/doSnsLogin", {
				self.axiosCaller.get(self, self.APIs.SESSION + "/doSnsLogin", {
					snsService: "naver",
					snsId: res.id,
				}, async (res) => {

					const result = res.data;

					if (result.status === "ok") {
						if (await self.setSessionProc(result.coAccountVO, opener)) {
							self.setSessionKeep( isKeepSession );
							self.goWithCoCode(self)
						}
					} else {
						self.swalUtils.gritter("Error", result.msg, "info", 1500)
					}
				})

			});
		},


		goReferrer () {
			const self = this

			if ( !this.stringUtils.isEmpty( this.$route.query.referrer ) ) {
				// console.log( this.$route.query.referrer )
				// opener.location.href = this.$route.query.referrer
				self.appClose({
					url: this.$route.query.referrer
				})
			} else {
				//opener.location.href = "/"
				self.appClose({
					url: "/"
				})
			}
		},

		naverSignInCallback() {

			// 네이버 사용자 프로필 조회 이후 프로필 정보를 처리할 callback function
			console.log( window.naver_id_login )
			alert(window.naver_id_login.getProfileData('email'));
			alert(window.naver_id_login.getProfileData('nickname'));
			alert(window.naver_id_login.getProfileData('age'));
		},

	}
}

</script>

<style scoped>

</style>
